<svg
  [ngStyle]="{
    width: width + 'px',
    height: height + 'px',
    color: color,
    transform: 'rotate(' + rotate + 'deg)',
  }"
  [ngClass]="customClasses"
  [class.chevron]="name === Icon.Chevron"
  [attr.aria-label]="!ariaHidden ? name + ' icon' : null"
>
  <!-- Normal weight icon -->
  <use
    class="icon-normal"
    [attr.xlink:href]="'assets/icons/sprites.svg#' + name"
  ></use>

  <!-- Overlay bold variant for chevron -->
  @if (name === Icon.Chevron) {
    <use
      class="icon-bold"
      [attr.xlink:href]="'assets/icons/sprites.svg#' + Icon.ChevronBold"
    ></use>
  }
</svg>
